<template>
    <b-row>
        <b-col md="12">
            <b-card>
                <b-form v-on:submit.prevent enctype="multipart/form-data">
                    <b-row>
                        <b-col cols="12 mb-1">
                            <b-badge variant="light-warning" v-if="form.status === 0">{{ form.status_name }}</b-badge>
                            <b-badge variant="light-success" v-else-if="form.status === 1">{{ form.status_name }}</b-badge>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group
                            label="Target Date"
                            label-for="target_date"
                            >
                                <flat-pickr
                                id="target_date"
                                v-model="form.target_date"
                                class="form-control"
                                placeholder="Target Date"
                                />
                                <!-- :config="{ dateFormat: 'd-m-Y'}" -->
                                <!-- <p>Value: '{{ form.target_date }}'</p> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-form-group
                            label="Employees"
                            label-for="employees"
                            >
                                <v-select
                                id="employees"
                                v-model="form.selectedEmployees"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="text"
                                :options="form.optionsEmployees"
                                placeholder="Select 1 Employee"
                                >
                                    <template #search="{attributes, events}">
                                        <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"
                                        />
                                    </template>
                                </v-select>
                                <!-- Selected: <strong>{{ form.selectedEmployees }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                            label="Title"
                            label-for="title"
                            >
                            <b-form-input
                                id="title"
                                placeholder="Title"
                                v-model="form.title"
                                class="form-control"
                                required
                            />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                            label="Priority"
                            label-for="priotiry"
                            >
                                <v-select
                                id="priotiry"
                                v-model="form.selectedPriority"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="text"
                                :options="form.optionsPriority"
                                placeholder="Select Priority"
                                >
                                    <template #search="{attributes, events}">
                                        <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"
                                        />
                                    </template>
                                </v-select>
                                <!-- Selected: <strong>{{ form2.selectedPriority }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group
                            label="Description"
                            label-for="description"
                            >
                            <b-form-textarea
                                id="description"
                                placeholder="Description"
                                v-model="form.description"
                                class="form-control"
                                required
                            />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col md="12">
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file1 !== null"
                            @click="link(form.file1)"
                            >
                            Attachment 1
                            </b-button>
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file2 !== null"
                            @click="link(form.file2)"
                            >
                            Attachment 2
                            </b-button>
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file3 !== null"
                            @click="link(form.file3)"
                            >
                            Attachment 3
                            </b-button>
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file4 !== null"
                            @click="link(form.file4)"
                            >
                            Attachment 4
                            </b-button>
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file5 !== null"
                            @click="link(form.file5)"
                            >
                            Attachment 5
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col md="12">
                            <label for="items" class="text-primary font-weight-bolder">Progress</label>
                        </b-col>
                        <b-col md="12">
                            <div>
                                <label>Update your progress before target date ends</label>
                                <b-progress
                                    :max="progress_max"
                                >
                                    <b-progress-bar :value="progress_value">
                                    <strong>{{ progress_value }}% / {{ progress_max }}%</strong>
                                    </b-progress-bar>
                                </b-progress>
                            </div>
                        </b-col>
                        <b-col md="12">
                            <b-button
                            class="mt-1"
                            type="submit"
                            variant="primary"
                            v-b-modal.modal-progress
                            >
                                Update Progress
                            </b-button>
                        </b-col>
                        <!-- modal progress -->
                        <b-modal
                        id="modal-progress"
                        title="Progress Form"
                        ok-title="Progress"
                        cancel-variant="outline-secondary"
                        hide-footer
                        >
                            <validation-observer ref="loginValidation">
                            <b-form ref="form" @submit.prevent>
                                <b-form-group
                                :state="errors"
                                label="Percentage (%)"
                                label-for="progress"
                                invalid-feedback="Progress required"
                                >
                                    <validation-provider
                                    #default="{ errors }"
                                    name="progress"
                                    rules="required"
                                    >
                                        <b-form-input
                                            id="progress"
                                            name="progress"
                                            type="number"
                                            min="0"
                                            max="100"
                                            step="0.01"
                                            v-model="progress_bar"
                                            :state="errors.length > 0 ? false:null"
                                            placeholder="Progress"
                                            required="required"
                                        />
                                        <small class="text-danger">{{ errors[0] || errMessage }}</small>
                                    </validation-provider>
                                </b-form-group>

                                <b-row>
                                    <b-col>
                                        <b-button
                                            class="mt-3"
                                            type="submit"
                                            variant="primary"
                                            block
                                            @click="updateProgress()"
                                        >
                                            Update Progress
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                            </validation-observer>
                        </b-modal>
                        <!-- end modal reject -->
                    </b-row>
                </b-form>
            </b-card>
        </b-col>
        <b-col md="12" v-if="permissions.includes('sales-target-update')">
            <b-button
            class="mt-0"
            type="submit"
            variant="primary"
            block
            @click="updateTarget()"
            >
                Update Target
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
import {
    BProgress, BProgressBar, BFormTextarea, BDropdownItem, BDropdown, BBadge, BPagination, BFormFile, BImg, BFormSelect, BListGroupItem, BAvatar, BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ImageUploader from 'vue-image-upload-resize'
import { $themeConfig } from "@themeConfig"
import Cleave from 'vue-cleave-component'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        flatPickr,
        VueGoodTable,
        ToastificationContent,
        vSelect,
        ImageUploader,
        Cleave,
        BProgress,
        BProgressBar,
        BFormTextarea,
        BPagination,
        BBadge,
        BDropdownItem,
        BDropdown,
        ValidationProvider,
        ValidationObserver,
        BFormFile,
        BImg,
        BFormSelect,
        BListGroupItem,
        BAvatar,
        BCard,
        BCardText,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BForm,
        BButton,
        Prism
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            form: {
                status: null,
                status_name: '',
                target_date: null,
                selectedEmployees: null,
                optionsEmployees: [],
                workers: [],
                title: '',
                selectedPriority: null,
                optionsPriority: [
                    {value: 1, text: 'Low'},
                    {value: 2, text: 'Normal'},
                    {value: 3, text: 'High'},
                    {value: 4, text: 'Urgent'}
                ],
                description: '',
                file1: null,
                file2: null,
                file3: null,
                file4: null,
                file5: null
            },
            progress_value: 0,
            progress_max: 100,
            progress_bar: null,
            hasImage: '',
            image: '',
            photo: '',
            pageLength: 10,
            dir: false,
            columns: [
                {
                label: 'Image',
                field: 'image',
                },
                {
                label: 'Code',
                field: 'code',
                },
                {
                label: 'Name',
                field: 'name',
                },
                {
                label: 'Qty',
                field: 'qty',
                },
                {
                label: 'Unit',
                field: 'unit_name',
                },
                {
                label: 'Price',
                field: 'price',
                },
                {
                label: 'Action',
                field: 'action',
                },
            ],
            permissions: [],
            rows: [],
            searchTerm: '',
            errors: '',
            errMessage: ''
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                1 : 'light-success',
                0 : 'light-danger'
            }

            return status => statusColor[status]
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    setup() {
        // App Name
        const { baseUrl, apiUrl } = $themeConfig.app;
        return {
            baseUrl,
            apiUrl
        };
    },
    created() {
        this.getAllPermissions()
        this.getDetails()
        this.getEmployees()
    },
    methods: {
        getAllPermissions() {
            this.permissions = sessionStorage.getItem('permissions')
        },
        getDetails() {
            const id = this.$route.params.id
            this.$http.get('sales/target/'+id)
            .then(response => {
                // console.log(response.data.data)
                this.form.status = response.data.data.status
                this.form.status_name = response.data.data.status_name
                this.form.target_date = response.data.data.target_date
                this.form.selectedEmployees = {value: response.data.data.worker.id, text: response.data.data.worker.name}
                this.form.title = response.data.data.title
                this.form.selectedPriority = {value: response.data.data.priority, text: response.data.data.priority_name}
                this.form.description = response.data.data.description
                this.progress_value = response.data.data.percentage
                this.progress_bar = response.data.data.percentage
                const { baseUrl } = $themeConfig.app
                if(response.data.data.attachment_1 !== '') {
                    this.form.file1 = baseUrl
                    this.form.file1 += 'storage/sales/target/'
                    this.form.file1 += response.data.data.attachment_1
                }
                if(response.data.data.attachment_2 !== '') {
                    this.form.file2 = baseUrl
                    this.form.file2 += 'storage/sales/target/'
                    this.form.file2 += response.data.data.attachment_2
                }
                if(response.data.data.attachment_3 !== '') {
                    this.form.file3 = baseUrl
                    this.form.file3 += 'storage/sales/target/'
                    this.form.file3 += response.data.data.attachment_3
                }
                if(response.data.data.attachment_4 !== '') {
                    this.form.file4 = baseUrl
                    this.form.file4 += 'storage/sales/target/'
                    this.form.file4 += response.data.data.attachment_4
                }
                if(response.data.data.attachment_5 !== '') {
                    this.form.file5 = baseUrl
                    this.form.file5 += 'storage/sales/target/'
                    this.form.file5 += response.data.data.attachment_5
                }
            })
        },
        link(url) {
            window.open(url)
        },
        getEmployees() {
            this.$http.get('employees')
            .then(response => { 
                // console.log(response.data.data)
                var datas = response.data.data
                var i
                for(i=0; i<datas.length; i++) {
                    var $data = {
                        value: datas[i].id,
                        text: datas[i].name
                    }
                    // console.log($data)
                    this.form.optionsEmployees.push($data)
                }
                // console.log(this.form.optionsEmployees)
            });
        },
        statusSubtask($data, $index) {
            this.$http.post('sales/task/item/'+$data.id+'/status')
            .then(response => { 
                // console.log(response.data.data)
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Subtask Change',
                        variant: 'primary',
                    },
                })
                this.items.splice($index, 1, {
                    id: response.data.data.id,
                    description: response.data.data.description,
                    status: response.data.data.status,
                    status_name: response.data.data.status_name
                })
            });
        },
        updateTarget() {
            if(this.form.target_date === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Target Date Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.selectedEmployees === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Employees Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.title === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Title Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.selectedPriority === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Priority Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.description === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Description Field is required',
                        variant: 'warning',
                    },
                })
            } else {
                let formData = new FormData();
                formData.append("target_date", this.form.target_date)
                formData.append("worker", this.form.selectedEmployees.value)
                formData.append("title", this.form.title)
                formData.append("description", this.form.description)
                formData.append("priority", this.form.selectedPriority.value)
                const id = this.$route.params.id
                this.$http
                .post("sales/target/"+id+"/update", formData)
                .then((response) => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: 'Success update Target',
                            variant: 'success',
                        },
                    })
                    location.href = "/sales/target"
                }).catch((errors) => {
                    this.errMessage = errors.response.data.message
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: this.errMessage,
                            variant: 'warning',
                        },
                    })
                    console.log(errors.response)
                });
            }
        },
        updateProgress() {
            if(this.progress_bar > 100) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Percentage cant higher than 100%',
                        variant: 'warning',
                    },
                })
            } else {
                const id = this.$route.params.id
                this.$http.post('sales/target/'+id+'/progress', {
                    percentage: this.progress_bar
                })
                .then(response => { 
                    // console.log(response.data.data)
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: 'Progress Updated',
                            variant: 'success',
                        },
                    })
                    location.reload()
                });
            }
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import "@core/scss/vue/libs/vue-good-table.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>